<template>
    <main class="login">
        <div class="logo"></div>
        <div class="signin" v-if="!signup">
            <input class="mb-4" :class="{error: errEmail}" type="text" name="email" v-model="email" placeholder="Email">
            <input class="mb-4" :class="{error: errPassword}" type="password" name="password" v-model="password" placeholder="Password">
            <button class="btn mt-1" @click="validateForm()">{{textLogin}}</button>
            <a class="signup mt-4" @click="switchForm()">{{textSignUp}}</a>
        </div>
        <div class="signup" v-if="signup">
            <input class="mb-4" :class="{error: errEmail}" type="text" name="email" v-model="email" placeholder="Email">
            <input class="mb-4" :class="{error: errPassword}" type="password" name="password" v-model="password" v-bind:placeholder="textPassword">
            <input class="mb-4" :class="{error: errCpassword}" type="password" name="passwordConfirm" v-model="passwordConfirm" placeholder="Confirm Password">
            <button class="btn mt-1" @click="validateForm()">{{textRegister}}</button>
            <a class="signup mt-4" @click="switchForm()">{{textCancel}}</a>
        </div>
        <img :src="'img/login-logo-'+localStorage.lang+'.png'"/>
    </main>
</template>

<script>
import Vue from "vue"
import CxltToastr from 'cxlt-vue2-toastr'
import 'cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css'

Vue.use(CxltToastr)

export default {
    name: 'login',
    data: function () {
        return {
            email:'',
            password:'',
            passwordConfirm:'',
            localStorage: localStorage,
            signup: false,
            errEmail: false,
            errPassword: false,
            errCpassword: false,
            errTitle: '',
            errMsg: '',
            textLogin: localStorage.lang =='en' ? 'Login' : "S'identifier",
            textSignUp: localStorage.lang =='en' ? 'Sign Up' : "Inscrire",
            textRegister: localStorage.lang =='en' ? 'Register' : "Registre",
            textCancel: localStorage.lang =='en' ? 'Cancel' : "Annuler",
            textPassword: localStorage.lang =='en' ? 'Password' : "Mot de passe",
            reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
        }
    },
    beforeMount: function () {
        localStorage.lang.length == 0 ? localStorage.lang = 'en' : ''
        if(this.localStorage.token) { // token validation
            this.axios.defaults.headers.common['Authorization'] = localStorage.getItem('token')
            this.axios.get(process.env.VUE_APP_URL+'profiles')
            .then(response => {
                this.$router.push({path:'/'})
            })
            .catch(error => {
                this.localStorage.token = ''
            });
        }
    },
    methods: {
        validateForm: function(){
            this.errEmail = false
            this.errPassword = false
            this.errCpassword = false
            this.errTitle = ''
            this.errMsg = ''
            // form validation
            if(!this.signup) {
                if(this.email == '' || !this.reg.test(this.email)) {
                    this.errEmail = true
                    this.errTitle = 'Login failure'
                    this.errMsg = this.errMsg + 'Email is not valid. '

                }
                if(this.password == '') {
                    this.errPassword = true
                    this.errTitle = 'Login failure'
                    this.errMsg = this.errMsg + 'Enter your password. '
                }
            } else {
                if(this.email == '' || !this.reg.test(this.email)) {
                    this.errEmail = true
                    this.errTitle = 'Sign up failure'
                    this.errMsg = this.errMsg + 'Email is not valid. '
                }
                if(this.password == '') {
                    this.errPassword = true
                    this.errTitle = 'Sign up failure'
                    this.errMsg = this.errMsg + 'Enter your password. '
                }
                if(this.passwordConfirm == '') {
                    this.errCpassword = true
                    this.errTitle = 'Sign up failure'
                    this.errMsg = this.errMsg + 'Enter password confirmation. '
                }
                if(this.password != this.passwordConfirm) {
                    this.errPassword = true
                    this.errCpassword = true
                    this.errTitle = 'Sign up failure'
                    this.errMsg = this.errMsg + 'Password and password confirmation should be the same. '
                }
            }
            // sending data to server
            if(!this.errEmail && !this.errPassword && !this.errCpassword) {
                if(!this.signup) {
                    this.axios.post(process.env.VUE_APP_URL+'login',{email: this.email, password: this.password})
                    .then(response => {
                        localStorage.token = 'Bearer ' + response.data.token
                        this.axios.defaults.headers.common['Authorization'] = localStorage.getItem('token')
                        this.$router.push({path:'/'})
                    })
                    .catch(error => {
                        this.$toast.error({
                            title:'Login Failure',
                            message: 'Invalid email or password',
                            position: 'top right',
                            timeOut: 5000
                        })
                    })
                } else {
                    this.axios.post(process.env.VUE_APP_URL+'register',{email: this.email, password: this.password, password_confirmation: this.passwordConfirm})
                    .then(response => {
                        this.$toast.success({
                            title:'Successful Registration',
                            message: 'Your account was created successfully - please log in',
                            position: 'top right',
                            timeOut: 5000
                        })
                        this.password = ''
                        this.passwordConfirm = ''
                        this.signup = false
                    })
                    .catch(error => {
                        let msg = []
                        for(var index in error.response.data) {
                            msg = msg + ' ' + error.response.data[index]
                        }
                        this.$toast.error({
                            title:'Register failure',
                            message: msg,
                            position: 'top right',
                            timeOut: 5000
                        })
                    })
                }
            } else { // displaying validation error msg
                this.$toast.error({
                    title:this.errTitle,
                    message: this.errMsg,
                    position: 'top right',
                    timeOut: 5000
                })
            }
        },
        switchForm: function() { // showing/hiding register form
            this.signup = !this.signup
            this.errEmail = false
            this.errPassword = false
            this.errCpassword = false
        }
    }
}

</script>
